export default function DiscountList(){
    return (<>discounts</>)
}